/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Sample } from './Sample';
import {
    SampleFromJSON,
    SampleFromJSONTyped,
    SampleToJSON,
    SampleToJSONTyped,
} from './Sample';

/**
 * 
 * @export
 * @interface BranchNetSalesTimeseriesResponse
 */
export interface BranchNetSalesTimeseriesResponse {
    /**
     * 
     * @type {Array<Sample>}
     * @memberof BranchNetSalesTimeseriesResponse
     */
    data: Array<Sample>;
}

/**
 * Check if a given object implements the BranchNetSalesTimeseriesResponse interface.
 */
export function instanceOfBranchNetSalesTimeseriesResponse(value: object): value is BranchNetSalesTimeseriesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BranchNetSalesTimeseriesResponseFromJSON(json: any): BranchNetSalesTimeseriesResponse {
    return BranchNetSalesTimeseriesResponseFromJSONTyped(json, false);
}

export function BranchNetSalesTimeseriesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BranchNetSalesTimeseriesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(SampleFromJSON)),
    };
}

export function BranchNetSalesTimeseriesResponseToJSON(json: any): BranchNetSalesTimeseriesResponse {
    return BranchNetSalesTimeseriesResponseToJSONTyped(json, false);
}

export function BranchNetSalesTimeseriesResponseToJSONTyped(value?: BranchNetSalesTimeseriesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(SampleToJSON)),
    };
}

